import createSvgIcon from '../Utils/CreateSvgIcon';

export const Download = createSvgIcon(
  <path d="M200-120v-40h560v40H200Zm279.23-150.77L254.62-568.46h130.76V-840h188.47v271.54h130.77L479.23-270.77Zm0-65.38 142.92-191.54h-88.3V-800H425.38v272.31h-88.3l142.15 191.54Zm.77-191.54Z" />,
  'Download',
  '0 -960 960 960',
);
